export const CircularScreenLoaderStyles = {
  flex: 1,
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: '#fff',
  zIndex: 1300,
  position: 'absolute'
};